module.exports = __webpack_public_path__ + "img/mobile-landing.4f496df1.png";